import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('description', { _component: () => FDBodyText }, overrideReadOnly);
